import { grow2792State } from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/reducer';
import { PackageList, PricingPackage } from '~shared/types/pricing/pricingsvc';

const NULL_PACKAGE = {} as PricingPackage;

export const packageState = {
  allPackages: [] as PricingPackage[],
  userPackage: {} as PricingPackage,
  displayPackages: [] as PricingPackage[],
  displayPackageSet: [],
  detailsPackageData: {},
  packagesToDisplayState: [] as PackageList,
  discountInfo: undefined,
  paidFeatures: undefined,
  showEduDiscount: false,
  comparePlans: false,
  overageCost: undefined,
  getPackageById: (): PricingPackage => NULL_PACKAGE,
};

export const combinedStates = {
  packages: packageState,
  grow2792: grow2792State,
};
